import * as React from "react";
import {
    getPrintDate, handleGrantTypes
} from "../detail/form_utility";
import {SectionWrapper} from "./index";
import {connect} from "react-redux";
import {IRootState} from "../../reducers";

class ShipmentinventoryformPreviewComponent extends React.Component<any, any> {

    public render() {
        const { values } = this.props.mainForm.mainForm;
        return (
            <SectionWrapper className='extra-margin-top'>
                <div className='PrintSectionHeader'>Shipment/Inventory</div>
                <div className="PrintContainerWrapper">
                    <div className='PrintItemContainer'>
                        <div  className='PrintItemLabel'>WBS No:</div>
                        <div className='PrintItemValue'>{values.shipments[0].wbsno}</div>
                    </div>
                    <div className='PrintItemContainer'>
                        <div  className='PrintItemLabel'>Grant No:
                        </div>
                        <div className='PrintItemValue'>{values.shipments[0].grantNo}</div>
                    </div>
                </div>
                <div className="PrintContainerWrapper">
                    <div className='PrintItemContainer'>
                        <div  className='PrintItemLabel'>Grant Expiry:
                        </div>
                        <div className='PrintItemValue'>{values.shipments[0].grantExpiry}</div>
                    </div>
                    <div className='PrintItemContainer'>
                        <div  className='PrintItemLabel'>Grant Type:</div>
                        <div className='PrintItemValue'>{handleGrantTypes(values.shipments[0].grantType)}</div>
                    </div>
                </div>
                <div className="PrintContainerWrapper">
                    <div className='PrintItemContainer'>
                        <div  className='PrintItemLabel'>Name of Third Party:

                        </div>
                        <div className='PrintItemValue'>{values.shipments[0].nameOfThirdParty}</div>
                    </div>
                    <div className='PrintItemContainer'>
                        <div  className='PrintItemLabel'>Amount of recovery obtained:
                        </div>
                        <div className='PrintItemValue'>{values.shipments[0].amountOfRecoveryObtained}</div>
                    </div>
                </div>
                <div className="PrintContainerWrapper">
                    <div className='PrintItemContainer'>
                        <div  className='PrintItemLabel'>Surveyor details: company name:
                        </div>
                        <div className='PrintItemValue'>{getPrintDate(values.shipments[0].surveyorDetailsCompanyName)}</div>
                    </div>                   
                </div>
                <div className="PrintContainerWrapper">                    
                    <div className='PrintItemContainer'>
                        <div  className='PrintItemLabel'>Contact person:
                        </div>
                        <div className='PrintItemValue'>{values.shipments[0].contactPerson}</div>
                    </div>
                </div>
                <div className="PrintContainerWrapper">
                    <div className='PrintItemContainer'>
                        <div  className='PrintItemLabel'>Address:
                        </div>
                        <div className='PrintItemValue'>{getPrintDate(values.shipments[0].sdaddress)}</div>
                    </div>
                    <div className='PrintItemContainer'>
                        <div  className='PrintItemLabel'>Email:
                        </div>
                        <div className='PrintItemValue'>{values.shipments[0].email}</div>
                    </div>
                </div>
                <div className="PrintContainerWrapper">
                    <div className='PrintItemContainer'>
                        <div  className='PrintItemLabel'>Telephone: </div>
                        <div className='PrintItemValue'>{values.shipments[0].telephone}</div>
                    </div>
                    <div className='PrintItemContainer'>
                        <div  className='PrintItemLabel'>Broker reference:
                        </div>
                        <div className='PrintItemValue'>{values.shipments[0].brokerReference}</div>
                    </div>
                </div>
                <div className="PrintContainerWrapper">
                    <div className='PrintItemContainer'>
                        <div  className='PrintItemLabel'>Claim designation: </div>
                        <div className='PrintItemValue'>{values.shipments[0].claimDesignation}</div>
                    </div>
                    <div className='PrintItemContainer'>
                        <div  className='PrintItemLabel'>Presented for settlement:
                        </div>
                        <div className='PrintItemValue'>{values.shipments[0].presentedForSettlement}</div>
                    </div>
                </div>
                <div className="PrintContainerWrapper">
                    <div className='PrintItemContainer'>
                        <div  className='PrintItemLabel'>Claim closed:
                        </div>
                        <div className='PrintItemValue'>{getPrintDate(values.shipments[0].claimClosed)}</div>
                    </div>
                    <div className='PrintItemContainer'>
                        <div  className='PrintItemLabel'>Settlement agreed:</div>
                        <div className='PrintItemValue'>{values.shipments[0].settlementAgreed}</div>
                    </div>
                </div>
                <div className="PrintContainerWrapper">
                    <div className='PrintItemContainer'>
                        <div  className='PrintItemLabel'>SD Settlement document No:</div>
                        <div className='PrintItemValue'>{values.shipments[0].sdsettlementDocumentNo}</div>
                    </div>
                </div>
            </SectionWrapper>

        )
    }
}

// export default ShipmentinventoryformPreviewComponent;

const mapStateToProps = (state: IRootState) => {
    return {
        mainForm: state.form
    };
};

// connect the form wrapper to the state store
export default connect(
    mapStateToProps,
    null
)(ShipmentinventoryformPreviewComponent)